import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function SpeedMedium({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M3.7878 9.31C2.0878 13.03 3.1278 17.43 6.3278 19.99M17.6492 19.9787C19.7592 18.2687 20.9992 15.6987 20.9892 12.9787C20.9814 9.0687 18.4854 5.74047 15.001 4.50354M6.31958 19.9787C4.20958 18.2687 2.96958 15.6987 2.97958 12.9787C2.98745 9.0687 5.48344 5.74047 8.9678 4.50354M12.001 10.9996V3.99963M11.9678 10.99C12.4982 10.99 13.0069 11.2007 13.382 11.5758C13.7571 11.9509 13.9678 12.4596 13.9678 12.99C13.9678 13.5204 13.7571 14.0291 13.382 14.4042C13.0069 14.7793 12.4982 14.99 11.9678 14.99C11.4374 14.99 10.9287 14.7793 10.5536 14.4042C10.1785 14.0291 9.9678 13.5204 9.9678 12.99C9.9678 12.4596 10.1785 11.9509 10.5536 11.5758C10.9287 11.2007 11.4374 10.99 11.9678 10.99Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default SpeedMedium;